import type { ManufacturingCase } from './project.model';

/** Maximum manufacturing methods (case groups) on one project. */
export const MAX_MANUFACTURING_METHODS = 4;

/** Maximum materials (variants) under a single manufacturing method. */
export const MAX_MATERIALS_PER_METHOD = 4;

/** Hard ceiling on child runs a single master may fan out into. */
export const MAX_TOTAL_VARIANTS = 8;

/**
 * Total child runs the given cases expand into. A case with no `variants`
 * array counts as one, matching the implicit single variant the fan-out
 * synthesises for unmigrated configs.
 */
export function countTotalVariants(
  cases: readonly Pick<ManufacturingCase, 'variants'>[],
): number {
  return cases.reduce((sum, c) => sum + Math.max(1, c.variants?.length ?? 0), 0);
}
